import { LinkModal } from '../../pages';
import React, { useState } from 'react';
import { observer } from 'mobx-react';
import { inventoryStore } from '../../stores';

const LinkModalContanier = ({ closeModal, goBack }) => {
	const [openLinkModal, setOpenLinkModal] = useState(true);

	return (
		<LinkModal
		    productType={ inventoryStore.selectedProduct}
			openLinkModal={openLinkModal}
			closeModal={closeModal}
			goBack={goBack}
		/>
	);
};

export default observer(LinkModalContanier);
